import { ReactNode, useContext } from "react";

import { TenantContext } from "../../auth/providers/tenant-provider";

export const RanaPageTitle = ({
  projectName,
  subTitle,
  showTenant,
}: {
  projectName?: string;
  subTitle: ReactNode;
  showTenant?: boolean;
}) => {
  const { tenant } = useContext(TenantContext);

  const beforeSubTitle = projectName ?? (showTenant ? tenant : undefined);
  return (
    <title>
      Rana &middot; {beforeSubTitle ? <>{beforeSubTitle} &middot;</> : null} {subTitle}
    </title>
  );
};
